import {
	confirmationContainerSX,
	confirmationIconBoxSX,
} from '@/components/content/ForgotPassword/styles/forgotPasswordConfirmation';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useLocalization } from '@/data/Localization';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { Box, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';

const REDIRECT_DELAY_MS = 3000;

export const ForgotPasswordConfirmation = ({ onGoToLogin }: { onGoToLogin?: () => void }) => {
	const nls = useLocalization('ForgotPassword');
	const RouteLocal = useLocalization('Routes');
	const router = useNextRouter();

	useEffect(() => {
		const timer = setTimeout(() => {
			if (onGoToLogin) {
				onGoToLogin();
				return;
			}

			router.push(`/${RouteLocal.Login.route.t()}`);
		}, REDIRECT_DELAY_MS);
		return () => clearTimeout(timer);
	}, [router, RouteLocal, onGoToLogin]);

	return (
		<Stack spacing={2} alignItems="center" sx={confirmationContainerSX}>
			<Box sx={confirmationIconBoxSX}>
				<TaskAltIcon sx={{ fontSize: 60 }} />
			</Box>
			<Typography variant="body1" color="grey.500">
				{nls.ConfirmationContentText.t()}
			</Typography>
		</Stack>
	);
};
